import { useLazyQuery } from '@apollo/client';
import { errorHandler } from 'utils/ErrorHandler';
import { GET_PRODUCT } from '..';

export function useQueryProduct() {
  const [getProduct, { data, refetch }] = useLazyQuery(GET_PRODUCT);

  const handleGetProduct = async (productId: string) => {
    if (productId === 'draft') {
      return;
    }

    try {
      await getProduct({ variables: { id: productId } });
    } catch (error) {
      console.log(error, 'product error');
    }
  };

  const handleRefetchProduct = async (
    productId: string,
    callback?: (productData: any) => void,
  ) => {
    try {
      const response = await refetch({ id: productId });

      if (response) {
        callback && callback(response.data.product);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return { data, handleGetProduct, handleRefetchProduct };
}
